import React, { useState } from "react";

import { CiImageOn } from "react-icons/ci";
import ImageComponent from "./ImageComponent";
import { SendIcon, Spinner } from "./icons";
import { useTheme } from "hooks/useTheme";
import { isColorDark } from "utils/utilityFunctions";

function MessageInput({
  handleInputMessage,
  message,
  sendMessage,
  loading,
  placeholder,
}) {
  const [imagePreviews, setImagePreviews] = useState([]);
  const [error, setError] = useState("");
  const [file, setFile] = useState();
  const handleFileChange = (e) => {
    const files = e.target.files;
    const validFiles = Array.from(files).filter((file) =>
      file.type.startsWith("image/")
    );

    if (validFiles.length !== files.length) {
      setError("Some files were not images and were not processed.");
    } else {
      setError("");
    }
    setFile(validFiles[0]);
    validFiles.forEach((file) => convertToBase64(file));
  };

  const convertToBase64 = (file) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      // setImagePreviews((prevState) => [...prevState, reader.result]);
      setImagePreviews([reader.result]);
    };
    reader.readAsDataURL(file);
  };

  const handleClick = () => {
    document.getElementById("fileInput").click();
  };

  const handleDelete = (index) => {
    const newArr = imagePreviews?.filter((item, idx) => idx !== index);
    setImagePreviews([...newArr]);
  };
  const theme = useTheme();
  return (
    <form
      onSubmit={async (e) => {
        e.preventDefault();
        await sendMessage(file);
        setFile(null);
        setImagePreviews([]);
      }}
      style={{ backgroundColor: theme.input }}
    >
      {/* <button style={buttonStyle} size="small">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          fill="none"
          viewBox="0 0 22 22"
          stroke="white"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 4v16m8-8H4"
          />
        </svg>
      </button> */}
      {imagePreviews.length > 0 && (
        <div
          style={{
            display: "flex",
            paddingLeft: "10px",
            paddingRight: "10px",
            paddingTop: "10px",
          }}
        >
          {imagePreviews?.map((item, index) => {
            return (
              <ImageComponent
                key={index}
                src={item}
                onDelete={() => handleDelete(index)}
              />
            );
          })}
        </div>
      )}

      <div style={style}>
        <div>
          <button style={imageButtonStyle}>
            <CiImageOn
              color={isColorDark(theme.input) ? "#ACACAC" : "black"}
              onClick={handleClick}
            >
              Select Image
            </CiImageOn>
          </button>

          <input
            id="fileInput"
            type="file"
            accept="image/*"
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
        </div>
        <input
          // fullWidth
          placeholder={placeholder}
          size="small"
          onChange={handleInputMessage}
          value={message}
          style={{
            marginLeft: "0.4rem",
            marginRight: "0.4rem",
            border: 0,
            outline: 0,
            backgroundColor: theme.input,
            width: "100%",
          }}
          autoFocus
        />
        {!loading ? (
          <button
            style={{
              ...buttonStyle,
              color: theme.primary,
              backgroundColor: theme.primary,
            }}
            size="small"
            type="submit"
            disabled={loading}
            // onClick={sendMessage}
          >
            <SendIcon color={theme.primary} />
          </button>
        ) : (
          <Spinner />
        )}
      </div>
    </form>
  );
}
export default MessageInput;
const imageButtonStyle = {
  all: "unset",
  display: "inline-block",
  cursor: "pointer",
  textAlign: "center",
  lineHeight: "normal",
  color: "inherit",
  backgroundColor: "transparent",
  border: "none",
  padding: "0",
  margin: "0",
  font: "inherit",
  outline: "none",
  boxShadow: "none",
  fontSize: "40px",
};
const style = {
  display: "flex",
  padding: "1rem",
};
const buttonStyle = {
  borderRadius: "50%",
  height: "45px",
  width: "50px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  border: "none",
  cursor: "pointer",
};
